require.context('./img', true);

import './style.css';
import './js/scripts';

